/* Bracketed tokens a template may carry; chat-kit seeds them, any template may use them. */
const CANDIDATE = '[candidate name]';
const JOB = '[job title]';
const OTHER_JOB = '[other job title]';
const TOPIC = '[work experience / education / skills]';

export const INFO_TOPICS = ['work experience', 'education', 'skills'] as const;

export interface FillContext {
  candidateName?: string;
  /** The chat's own job; absent in a Direct Message. */
  jobTitle?: string;
}

export interface FillPicks {
  jobTitle?: string;
  otherJobTitle?: string;
  topic?: string;
}

/** What the employer must still choose before the template can land whole. */
export function templateNeeds(body: string, ctx: FillContext) {
  return {
    job: body.includes(JOB) && !ctx.jobTitle,
    otherJob: body.includes(OTHER_JOB),
    topic: body.includes(TOPIC),
  };
}

export function fillTemplate(body: string, ctx: FillContext, picks: FillPicks = {}): string {
  const name = ctx.candidateName?.trim();
  const job = ctx.jobTitle ?? picks.jobTitle;
  let out = body;
  // "Hi [candidate name]," reads as "Hi," when the name is unknown.
  out =
    name && name !== 'Unknown'
      ? out.replaceAll(CANDIDATE, name)
      : out.replaceAll(` ${CANDIDATE}`, '').replaceAll(CANDIDATE, '');
  if (job) out = out.replaceAll(JOB, job);
  if (picks.otherJobTitle) out = out.replaceAll(OTHER_JOB, picks.otherJobTitle);
  if (picks.topic) out = out.replaceAll(TOPIC, picks.topic);
  return out;
}
